import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';
import { ArgoMaterialStatusEnum } from '@redviking/argonaut-util/types/db-enums/argo/material_status';

export const staticMaterialStatusEnumSchema = z.enum([
    ArgoMaterialStatusEnum.Pending,
    ArgoMaterialStatusEnum.InProgress,
    ArgoMaterialStatusEnum.Scrapped,
    ArgoMaterialStatusEnum.Quarantined,
    ArgoMaterialStatusEnum.ManuallyCompleted,
    ArgoMaterialStatusEnum.Completed,
]);

export const updateMaterialStatusCfgSchema = baseNodeCfgSchema.extend({
    controlValues: z.object({
        status: staticMaterialStatusEnumSchema,
    }),
    kind: z.literal('updateMaterialStatus'),
});
interface UpdateMaterialStatusCfgSchema extends z.infer<typeof updateMaterialStatusCfgSchema> {}

export const updateMaterialStatusSocketCfg = {
    controlSockets: {
        outputs: () => ({ next: 'event' }),
        inputs: () => ({ trigger: 'event' }),
    },
    dataSockets: {
        outputs: () => ({}),
        inputs: () => ({
            materialId: 'string',
        }),
    },
} satisfies NodeSocketCfg<UpdateMaterialStatusCfgSchema>;
